import { Row, Col } from "antd";
import Panels from "./Panels";

const Dyno = () => {
  return (
    <Row>
      <Col span={24}>
        <Panels />
      </Col>
    </Row>
  );
};

export default Dyno;
